import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import NotFoundPage from '../themes/NotFoundPage';
import OutdoorActivities from '../themes/OutdoorActivities';
import ExampleActivity from '../themes/ExampleActivity';
import LandingPage from '../themes/LandingPage';
import PrivacyPage from '../themes/PrivacyPage';
import ManagePage from '../themes/ManagePage';
import { ProtectedRoute } from './protected.route';
import UtahNationalParksRoadTrip from '../themes/UtahNationalParksRoadTrip';
import ThingsToDoInVegasBesidesParty from '../themes/ThingsToDoInVegasBesidesParty';
import KayakColoradoRiver from '../themes/KayakColoradoRiver';
import HowToPlanSustainableHikingTrip from '../themes/HowToPlanSustainableHikingTrip';
import GlacierNationalParkMemorialDay from '../themes/GlacierNationalParkMemorialDay';
import ChainLakesLoop from '../themes/ChainLakesLoop';
import HowToUseHikingPolesCorrectly from '../themes/HowToUseHikingPolesCorrectly';
import HowToMakeHikingStick from '../themes/HowToMakeHikingStick';
import HowToFindEcoFriendlyHikingGear from '../themes/HowToFindEcoFriendlyHikingGear';
import HowToProtectYourselfFromWildlifeWhileHiking from '../themes/HowToProtectYourselfFromWildlifeWhileHiking';
import HowToLaceHikingBoots from '../themes/HowToLaceHikingBoots';
import HowToTrainForHighAltitudeHiking from '../themes/HowToTrainForHighAltitudeHiking';
import HowToPackHikingBackpackDiagram from '../themes/HowToPackHikingBackpackDiagram';  
import HowToPreventBlistersWhenHiking from '../themes/HowToPreventBlistersWhenHiking';
import SubmitItineraryPage from '../themes/SubmitItineraryPage';
import ItineraryPage from '../themes/ItineraryPage';
import UserPage from '../themes/UserPage';
import EditProfilePage from '../themes/EditProfilePage';
import BlogCollectionPage from '../themes/BlogCollectionPage';
import ItinerariesCollectionPage from '../themes/ItinerariesCollectionPage';
import DynamicPost from '../themes/DynamicPost';
import OlympicPeninsulaLoop from '../themes/OlympicPeninsulaLoop';
import GrandCanyonSouthRim from '../themes/GrandCanyonSouthRim';
import SedonaHiking from '../themes/SedonaHiking';
import YellowstoneGrandTeton from '../themes/YellowstoneGrandTeton';
import TripFinderPage from '../themes/TripFinderPage';
import GreatSmokyMountains from '../themes/GreatSmokyMountains';
import AcadiaNationalPark from '../themes/AcadiaNationalPark';
import BlueRidgeParkway from '../themes/BlueRidgeParkway';
import RockyMountainNationalPark from '../themes/RockyMountainNationalPark';
import BoundaryWatersCanoeArea from '../themes/BoundaryWatersCanoeArea';
import ZionNationalPark from '../themes/ZionNationalPark';
import BanffNationalPark from '../themes/BanffNationalPark';
import ShenandoahNationalPark from '../themes/ShenandoahNationalPark';
export default class Routes extends React.PureComponent {
  render() {
    return (
      <>
        <Router>
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Redirect from="/login" to="/submit-itinerary" />
            <Redirect from="/blog" to="/hiking-guides" />
            <Redirect from="/kayak-colorado-river" to="/itineraries/kayak-colorado-river" />
            <Redirect from="/utah-national-parks-road-trip" to="/itineraries/utah-national-parks-road-trip" />
            <Redirect from="/things-to-do-in-vegas-besides-party" to="/itineraries/things-to-do-in-vegas-besides-party" />
            <Redirect from="/glacier-national-park-memorial-day" to="/itineraries/glacier-national-park-memorial-day" />
            <Redirect from="/chain-lakes-loop" to="/itineraries/chain-lakes-loop" />
            <Redirect from="/how-to-plan-sustainable-hiking-trip" to="/hiking-guides/how-to-plan-sustainable-hiking-trip" />
            <Redirect from="/how-to-use-hiking-poles-correctly" to="/hiking-guides/how-to-use-hiking-poles-correctly" />
            <Redirect from="/how-to-make-hiking-stick" to="/hiking-guides/how-to-make-hiking-stick" />
            <Redirect from="/how-to-find-eco-friendly-hiking-gear" to="/hiking-guides/how-to-find-eco-friendly-hiking-gear" />
            <Redirect from="/how-to-protect-yourself-from-wildlife-while-hiking" to="/hiking-guides/how-to-protect-yourself-from-wildlife-while-hiking" />
            <Redirect from="/how-to-lace-hiking-boots" to="/hiking-guides/how-to-lace-hiking-boots" />
            <Redirect from="/how-to-train-for-high-altitude-hiking" to="/hiking-guides/how-to-train-for-high-altitude-hiking" />
            <Redirect from="/how-to-pack-hiking-backpack-diagram" to="/hiking-guides/how-to-pack-hiking-backpack-diagram" />
            <Redirect from="/how-to-prevent-blisters-when-hiking" to="/hiking-guides/how-to-prevent-blisters-when-hiking" />
            <Route exact path="/privacy" component={PrivacyPage} />
            <Route exact path="/outdoor-activities" component={OutdoorActivities} />
            <Route exact path="/itineraries/utah-national-parks-road-trip" component={UtahNationalParksRoadTrip} />
            <Route exact path="/itineraries/things-to-do-in-vegas-besides-party" component={ThingsToDoInVegasBesidesParty} />
            <Route exact path="/hiking-guides/how-to-plan-sustainable-hiking-trip" component={HowToPlanSustainableHikingTrip} />
            <Route exact path="/hiking-guides/how-to-make-hiking-stick" component={HowToMakeHikingStick} />
            <Route exact path="/hiking-guides/how-to-use-hiking-poles-correctly" component={HowToUseHikingPolesCorrectly} />
            <Route exact path="/hiking-guides/how-to-protect-yourself-from-wildlife-while-hiking" component={HowToProtectYourselfFromWildlifeWhileHiking} />
            <Route exact path="/hiking-guides/how-to-find-eco-friendly-hiking-gear" component={HowToFindEcoFriendlyHikingGear} />
            <Route exact path="/hiking-guides/how-to-lace-hiking-boots" component={HowToLaceHikingBoots} />
            <Route exact path="/hiking-guides/how-to-train-for-high-altitude-hiking" component={HowToTrainForHighAltitudeHiking} />
            <Route exact path="/hiking-guides/how-to-pack-hiking-backpack-diagram" component={HowToPackHikingBackpackDiagram} />
            <Route exact path="/hiking-guides/how-to-prevent-blisters-when-hiking" component={HowToPreventBlistersWhenHiking} />
            <Route exact path="/itineraries/glacier-national-park-memorial-day" component={GlacierNationalParkMemorialDay} />
            <Route exact path="/itineraries/kayak-colorado-river" component={KayakColoradoRiver} />
            <Route exact path="/hiking-guides" component={BlogCollectionPage} />
            <Route exact path="/itineraries" component={ItinerariesCollectionPage} />
            <Route exact path="/find-my-trip" component={TripFinderPage} />
            <Redirect from="/request-itinerary" to="/find-my-trip" />
            <Route exact path="/submit-itinerary" component={SubmitItineraryPage} />
            <Route exact path="/itinerary/:id" component={ItineraryPage} />
            <Route exact path="/user/:uid" component={UserPage} />
            <Route exact path="/profile/edit" component={EditProfilePage} />
            <Route exact path="/itineraries/chain-lakes-loop" component={ChainLakesLoop} />
            <Route exact path="/moab-utv-tour" component={ExampleActivity} />
            <Route exact path="/itineraries/olympic-peninsula-loop" component={OlympicPeninsulaLoop} />
            <Route exact path="/itineraries/grand-canyon-south-rim" component={GrandCanyonSouthRim} />
            <Route exact path="/itineraries/sedona-hiking" component={SedonaHiking} />
            <Route exact path="/itineraries/yellowstone-grand-teton" component={YellowstoneGrandTeton} />
            <Route exact path="/itineraries/great-smoky-mountains-national-park" component={GreatSmokyMountains} />
            <Route exact path="/itineraries/acadia-national-park" component={AcadiaNationalPark} />
            <Route exact path="/itineraries/blue-ridge-parkway" component={BlueRidgeParkway} />
            <Route exact path="/itineraries/rocky-mountain-national-park" component={RockyMountainNationalPark} />
            <Route exact path="/itineraries/boundary-waters-canoe-area" component={BoundaryWatersCanoeArea} />
            <Route exact path="/itineraries/zion-national-park" component={ZionNationalPark} />
            <Route exact path="/itineraries/zion-national-park-itinerary" component={ZionNationalPark} />
            <Route exact path="/itineraries/banff-national-park" component={BanffNationalPark} />
            <Route exact path="/itineraries/shenandoah-national-park" component={ShenandoahNationalPark} />
            <Route path="/hiking-guides/:slug" component={DynamicPost} />
            <Route path="/itineraries/:slug" component={DynamicPost} />
            <ProtectedRoute exact path="/manage" component={ManagePage} />
            <Route path="*" component={NotFoundPage} />
          </Switch>
        </Router>
      </>
    );
  }
}
